import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';

interface SuggestItem {
  id: number;
  value: string;
}

interface AutocompleteInputProps {
  value: string;
  onChange: (v: string) => void;
  suggestions: SuggestItem[];
  onDelete: (id: number) => void;
  placeholder?: string;
}

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({
  value, onChange, suggestions, onDelete, placeholder
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const filtered = value.trim()
    ? suggestions.filter(s => s.value.toLowerCase().includes(value.toLowerCase()))
    : suggestions;

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        value={value}
        onChange={e => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
      />
      {open && filtered.length > 0 && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
          zIndex: 200,
          background: 'var(--bg-canvas)',
          border: '1px solid var(--glass-border)',
          borderRadius: 'var(--r-sm)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          maxHeight: 200,
          overflowY: 'auto',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        }}>
          {filtered.map(item => (
            <div
              key={item.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '9px 12px',
                borderBottom: '1px solid var(--glass-border)',
                gap: 8,
              }}
            >
              <span
                onClick={() => { onChange(item.value); setOpen(false); }}
                style={{
                  flex: 1,
                  fontSize: 14,
                  color: 'var(--text0)',
                  cursor: 'pointer',
                  fontFamily: 'var(--sans)',
                }}
              >
                {item.value}
              </span>
              <button
                type="button"
                onClick={e => { e.stopPropagation(); onDelete(item.id); }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 2,
                  display: 'flex',
                  alignItems: 'center',
                  opacity: 0.5,
                  flexShrink: 0,
                }}
              >
                <Icon name="close" size={13} color="var(--red)" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AutocompleteInput;
